import { SettingsMenuIcon } from '@/assets/icons/menu-icons/settings';
import Header, { HeaderIconWrap, HeaderTitle, HeaderTitleWrap } from '@/components/header';
import { TableBodyWrapper, TableRowCell, TableRowWrapper, TableWrapper, TextCell } from '@/components/table/styles';
import TableHeader from '@/components/table/tableHeader';
import { TableColumns } from '@/components/table/types';
import { useResponsive } from '@/hooks/use-responsive';
import { MainWrap, PaddingWrap } from '@/styles/common';
import { themeVar } from '@/styles/theme';
import { Helmet as Head } from 'react-helmet';
import useRefresh from '../../hooks/use-refresh';

const dataIntegrityTableColumns: TableColumns[] = [
  { title: 'MOCKED_COLUMN_1', key: 'MOCKED_COLUMN_1' },
  { title: 'MOCKED_COLUMN_2', key: 'MOCKED_COLUMN_2' },
  { title: 'MOCKED_COLUMN_3', key: 'MOCKED_COLUMN_3' },
  { title: 'MOCKED_COLUMN_4', key: 'MOCKED_COLUMN_4' }
];
const COLUMN_WIDTH = 100 / dataIntegrityTableColumns.length;

const DataIntegrityPage = () => {
  useRefresh();
  const { isMobile, isTablet } = useResponsive();

  return (
    <>
      <Head>
        <title>Data Integrity</title>
      </Head>
      <MainWrap>
        <Header
          modalControl={
            <HeaderTitleWrap>
              <HeaderIconWrap>
                <SettingsMenuIcon style={{ width: isMobile ? 33 : 40, height: isMobile ? 33 : 40 }} fill={themeVar('font.strong')} />
                <HeaderTitle isTablet={isTablet} isMobile={isMobile}>
                  Data Integrity
                </HeaderTitle>
              </HeaderIconWrap>
            </HeaderTitleWrap>
          }
        />
      </MainWrap>
      <MainWrap>
        <PaddingWrap>
          <TableWrapper padding="50px 0">
            <TableHeader refetch={() => {}} columns={dataIntegrityTableColumns} withOutSort />
            <TableBodyWrapper>
              {[...Array(5)].map((row, index) => (
                <TableRowWrapper key={index}>
                  {dataIntegrityTableColumns.map((column) => (
                    <TableRowCell key={column.key} width={COLUMN_WIDTH}>
                      <TextCell>MOCKED_DATA</TextCell>
                    </TableRowCell>
                  ))}
                </TableRowWrapper>
              ))}
            </TableBodyWrapper>
          </TableWrapper>
        </PaddingWrap>
      </MainWrap>
    </>
  );
};

export default DataIntegrityPage;
